import React from "react";
import { useDictionary } from "@adamlip/okeoke.client";
import { useNavigate } from "react-router-dom";

function NotAvailableModule(props) {
  let navigate = useNavigate();

  const { getValue } = useDictionary();

  const handleClickBack = () => {
    navigate(-1);
  };

  return (
    <div className="notAvailable-root">
      <h2>{getValue("app_v2_moduleNotAvailable_title")}</h2>
      <br />
      <button className="btn primary" onClick={handleClickBack}>
        {getValue("app_v2_moduleNotAvailable_back")}
      </button>
    </div>
  );
}

export default NotAvailableModule;
